module.exports = __webpack_public_path__ + "img/huodongtongji.d6ee22e1.png";